<template>
    <div class="text-truncate" :class="{ 'cursor-pointer': isTruncated }" :id="id" :style="{ maxWidth: props.maxWidth }" ref="textRef">
        {{ props.value }}
    </div>
    <DxPopover v-if="isTruncated" :width="300" :target="`#${id}`" show-event="mouseenter" hide-event="mouseleave" position="top">
        {{ props.value }}
    </DxPopover>
</template>

<script setup lang="ts">
import { uniqueId } from 'lodash';
import { ref, onMounted, watch } from 'vue';
import DxPopover from 'devextreme-vue/popover';

const props = withDefaults(defineProps<{
    value: string | null;
    maxWidth?: string;
}>(), {
    maxWidth: '250px'
});

const id = uniqueId('long-text-with-tooltip-');
const textRef = ref<HTMLElement | null>(null);
const isTruncated = ref(false);

function checkTruncation() {
    const el = textRef.value;
    if (el) {
        isTruncated.value = el.scrollWidth > el.clientWidth;
    }
}

onMounted(checkTruncation);

watch(
    () => [props.value, props.maxWidth],
    () => checkTruncation(),
    { flush: 'post' }
);
//onUpdated(checkTruncation);
</script>

<style lang="scss" scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>